<div class="bg">
    <div class="container h-100">
        <div class="row h-100 justify-content-center align-items-center">
            <div class="col-10 col-sm-8 col-md-6 col-lg-4 text-center">
                <img src="assets/img/taskradar.png" class="img-fluid mx-auto d-block pt-3" alt="TaskRadar">
                <h3 class="pt-2">Aufgabenmanagement</h3>
                <router-outlet/>
            </div>
        </div>
    </div>
</div>

